// extracted by mini-css-extract-plugin
module.exports = {"header":"SidebarContainer_header__u7hZh","sidebarTitle":"SidebarContainer_sidebarTitle__iAyLQ"};